import { KeyboardEvent } from 'react';

interface UseAccessibilityOptionHandlersParams<T> {
  onEnter: (e: T) => void
  onSpace: (e: T) => void
  onUp: (e: T) => void
  onDown: (e: T) => void
}

/**
 * T element sur lequel est appliqué le keyboard event
 * @param param
 */
export function useAccessibilityOptionHandlers<T>({
  onEnter,
  onSpace,
  onUp,
  onDown,
}: UseAccessibilityOptionHandlersParams<T>): [(e: KeyboardEvent<T>) => void] {
  // ici e représente l'event keyboard appliqué
  function handleKeyDownEventForAccessibility(e: KeyboardEvent<T>) {
    switch (e.key) {
      case 'ArrowDown': { // Arrow Down
        e.preventDefault();
        e.stopPropagation();
        onUp(e?.currentTarget);
        break;
      }
      case 'ArrowUp': { // Arrow Up
        e.preventDefault();
        e.stopPropagation();
        onDown(e?.currentTarget);
        break;
      }
      case ' ': { // Space
        if (typeof onSpace === 'function') {
          e.preventDefault();
          e.stopPropagation();
          // simulate click on label behavior
          onSpace(e.currentTarget);
        }
        break;
      }
      case 'Enter': { // Enter
        if (typeof onEnter === 'function') {
          onEnter(e.currentTarget);
        }
        break;
      }
      default: {
        break;
      }
    }
  }
  return [handleKeyDownEventForAccessibility];
}
